export default __webpack_public_path__ + "static/media/footer.a458c78d.jpg";